import {
  DietIdEnum,
  DietModeType,
  SystemOfMeasuresEnum,
  UserMeasurementHeightUnitType,
  UserMeasurementWeightUnitType,
} from '@front-activerse/common-components';
import { dietSettings } from '../types';

const createFormikInitialValues = (
  dietSettingsData: any,
  dietTypes: {
    id: number;
    value: DietIdEnum;
    optionTitle: string;
    optionDescription: string;
    macro?: {
      protein: number;
      fat: number;
      carbs: number;
    };
  }[],
  dietLevels: {
    id: number;
    value: DietIdEnum;
    optionTitle: string;
    optionDescription: string;
    macro?: {
      protein: number;
      fat: number;
      carbs: number;
    };
  }[],
  appBrand: string
) => {
  const me = dietSettingsData.me;

  let dietMode = me.diet.mode;
  if (dietMode === DietModeType.put_on_weight) {
    dietMode = DietModeType.gain_muscle_mass;
  }

  const calculateDietLevel = () => {
    // for DTBA diet
    if (appBrand === 'dtba') {
      if (me.diet.id && dietLevels) {
        return dietLevels.find((level) => level.id === me.diet.id)?.value || null;
      }
      return null;
    } else if (appBrand === 'oxy') {
      // only for oxy diet
      if (me.diet.id === 1 || me.diet.id === 2) {
        if (me.isVegetarian) {
          return 'DIET_ID_OXY_VEGE';
        }
        if (me.isPescoVegetarian) {
          return 'DIET_ID_OXY_VEGE_FISH';
        }
        return 'DIET_ID_OXY_CLASSIC';
      } else if (me.diet.id === 3 || me.diet.id === 4) {
        if (me.isVegetarian) {
          return 'DIET_ID_CLASSIC_SIMPLE_VEGE';
        }
        return 'DIET_ID_SIMPLE_CLASSIC';
      }
    }

    return null;
  };

  const dietSettings: dietSettings = {
    sex: me.sex,
    dateOfBirth: me.birthDate,
    heightValue: Math.round(me.height?.value) || undefined,
    heightUnit:
      me.systemOfMeasures === SystemOfMeasuresEnum.imperial
        ? UserMeasurementHeightUnitType.in
        : UserMeasurementHeightUnitType.cm,
    heightFt: undefined,
    heightIn: undefined,
    weightValue: me.lastMeasurement?.weight[0]?.value,
    weightUnit:
      me.systemOfMeasures === SystemOfMeasuresEnum.imperial
        ? UserMeasurementWeightUnitType.lb
        : UserMeasurementWeightUnitType.kg,
    goalWeightValue: me.goalWeight?.value,
    goalWeightUnit:
      me.systemOfMeasures === SystemOfMeasuresEnum.imperial
        ? UserMeasurementWeightUnitType.lb
        : UserMeasurementWeightUnitType.kg,
    dietMode,
    dietType:
      me.diet.id && dietTypes
        ? dietTypes.find((type) => type.id === me.diet.id)?.value || null
        : null,
    dietName: me.diet.name || '',
    dietLevel: calculateDietLevel(),
    dietVariant: me.diet.dietType || null,
    activityLevel: me.diet.activityLevel,
    spontaneousActivityLevel: me.diet.spontaneousActivityLevel,
    baseCalories: dietSettingsData.dailyTracker?.data?.baseCalories || 0,
    macronutrientRatio: me.diet.macronutrientRatio || {
      protein: 0,
      fat: 0,
      carbohydrate: 0,
    },
    preferredMacronutrientRatio: me.diet.preferredMacronutrientRatio || {
      protein: 0,
      fat: 0,
      carbohydrate: 0,
    },
    acceptance: false,
  };

  return dietSettings;
};

export default createFormikInitialValues;
